import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed, effect, input, output, signal } from '@angular/core';

import { AuthorityScopeStore } from '../../models/store-authority.model';

const COLLAPSED_ROWS = 6;
const STORES_PER_ROW = 2;

@Component({
  selector: 'app-authority-scope-store-panel',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './authority-scope-store-panel.component.html',
  styleUrls: ['./authority-scope-store-panel.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AuthorityScopeStorePanelComponent {
  readonly scopeName = input.required<string>();
  readonly stores = input<AuthorityScopeStore[]>([]);
  readonly closed = output<void>();

  readonly expanded = signal(false);
  readonly collapsedSize = COLLAPSED_ROWS * STORES_PER_ROW;
  readonly visibleStores = computed(() =>
    this.expanded() ? this.stores() : this.stores().slice(0, this.collapsedSize)
  );
  readonly canExpand = computed(() => this.stores().length > this.collapsedSize);

  constructor() {
    effect(
      () => {
        this.stores();
        this.expanded.set(false);
      },
      { allowSignalWrites: true }
    );
  }

  toggleExpand() {
    this.expanded.update(expanded => !expanded);
  }
}
